// extracted by mini-css-extract-plugin
export default {"wrapper":"ao-z","response":"bo-z","error":"co-z","disabled":"do-z","buttons":"eo-z","feedbackQuestionSection":"fo-z","yesNoWrapper":"go-z"};